import moment from 'moment';
import {
  Report,
  ReportType,
  ReportSchedule,
  CHANNEL_TYPE,
} from './Report.model';

export const DEFAULT_MOCK_PDF_URL =
  'https://www.st-cloudconnect.com/example-pdf_01_09_2025.pdf';

export const reportTypeMocks: ReportType[] = [
  {
    id: '1',
    name: 'Sensor performance',
    description: 'Description for Sensor performance',
    isDefault: false,
    supportedFormats: ['pdf', 'csv', 'json'],
    labels: {
      key1: 'Label 1',
      key2: 'Label 2',
    },
    workspaceId: 'workspace-1',
  },
  {
    id: '2',
    name: 'Consumption Analysis',
    description: 'Description for Consumption Analysis',
    isDefault: true,
    supportedFormats: ['pdf', 'csv'],
    labels: {
      key1: 'Label 1',
      key2: 'Label 2',
    },
    workspaceId: 'workspace-1',
  },
];

export const reportSchedulesMock: ReportSchedule[] = [
  {
    id: 's1',
    reportEntityMap: [{ workspaceId: 'workspace-1', groupId: 'group-1' }],
    intervalType: 'day',
    intervalValue: 1,
    startTime: moment().subtract(10, 'days').toISOString(),
    reportSpec: {
      reportTitle: 'Daily Energy Usage',
      reportType: reportTypeMocks[0],
      channels: [
        {
          deviceID: 'dev-1',
          cuID: 'cu-1',
          channelID: 'ch-1',
          type: CHANNEL_TYPE.ANALOG,
          minThreshold: 0,
          maxThreshold: 1000,
        },
      ],
      intervalTimeInSeconds: 3600,
      exportFormats: ['pdf', 'csv'],
    },
  },
  {
    id: 's2',
    reportEntityMap: [
      { workspaceId: 'workspace-1', commanderId: 'commander-1' },
    ],
    intervalType: 'week',
    intervalValue: 1,
    startTime: moment().subtract(4, 'weeks').toISOString(),
    reportSpec: {
      reportTitle: 'Weekly Temperature',
      reportType: reportTypeMocks[1],
      channels: [
        {
          deviceID: 'dev-2',
          cuID: 'cu-2',
          channelID: 'ch-2',
          type: CHANNEL_TYPE.ANALOG,
          minThreshold: -10,
          maxThreshold: 50,
        },
      ],
      intervalTimeInSeconds: 7200,
      exportFormats: ['pdf', 'csv'],
    },
  },
  {
    id: 's3',
    reportEntityMap: [{ workspaceId: 'workspace-2', controlUnitId: 'cu-3' }],
    intervalType: 'month',
    intervalValue: 1,
    startTime: moment().subtract(2, 'months').toISOString(),
    reportSpec: {
      reportTitle: 'Monthly Humidity',
      reportType: reportTypeMocks[0],
      channels: [
        {
          deviceID: 'dev-3',
          cuID: 'cu-3',
          channelID: 'ch-3',
          type: CHANNEL_TYPE.ANALOG,
          minThreshold: 0,
          maxThreshold: 100,
        },
      ],
      intervalTimeInSeconds: 86400,
      exportFormats: ['pdf', 'json'],
    },
  },
  {
    id: 's4',
    reportEntityMap: [{ workspaceId: 'workspace-2', groupId: 'group-2' }],
    intervalType: 'day',
    intervalValue: 2,
    startTime: moment().subtract(20, 'days').toISOString(),
    reportSpec: {
      reportTitle: 'Voltage Check',
      reportType: reportTypeMocks[1],
      channels: [
        {
          deviceID: 'dev-4',
          cuID: 'cu-4',
          channelID: 'ch-4',
          type: CHANNEL_TYPE.ANALOG,
          minThreshold: 110,
          maxThreshold: 240,
        },
      ],
      intervalTimeInSeconds: 600,
      exportFormats: ['csv', 'json'],
    },
  },
  {
    id: 's5',
    reportEntityMap: [{ workspaceId: 'workspace-3' }],
    intervalType: 'month',
    intervalValue: 2,
    startTime: moment().subtract(3, 'months').toISOString(),
    reportSpec: {
      reportTitle: 'Pressure Monthly',
      reportType: reportTypeMocks[0],
      channels: [
        {
          deviceID: 'dev-5',
          cuID: 'cu-5',
          channelID: 'ch-5',
          type: CHANNEL_TYPE.ANALOG,
          minThreshold: 0,
          maxThreshold: 10,
        },
      ],
      intervalTimeInSeconds: 1800,
      exportFormats: ['pdf'],
    },
  },
  {
    id: 's6',
    reportEntityMap: [
      { workspaceId: 'workspace-3', commanderId: 'commander-2' },
    ],
    intervalType: 'year',
    intervalValue: 1,
    startTime: moment().subtract(1, 'years').toISOString(),
    reportSpec: {
      reportTitle: 'CO2 Yearly',
      reportType: reportTypeMocks[1],
      channels: [
        {
          deviceID: 'dev-6',
          cuID: 'cu-6',
          channelID: 'ch-6',
          type: CHANNEL_TYPE.ANALOG,
          minThreshold: 0,
          maxThreshold: 2000,
        },
      ],
      intervalTimeInSeconds: 3600,
      exportFormats: ['csv'],
    },
  },
  {
    id: 's7',
    reportEntityMap: [{ workspaceId: 'workspace-4', groupId: 'group-3' }],
    intervalType: 'week',
    intervalValue: 2,
    startTime: moment().subtract(8, 'weeks').toISOString(),
    reportSpec: {
      reportTitle: 'Light Intensity Biweekly',
      reportType: reportTypeMocks[0],
      channels: [
        {
          deviceID: 'dev-7',
          cuID: 'cu-7',
          channelID: 'ch-7',
          type: CHANNEL_TYPE.ANALOG,
          minThreshold: 0,
          maxThreshold: 10000,
        },
      ],
      intervalTimeInSeconds: 43200,
      exportFormats: ['json'],
    },
  },
  {
    id: 's8',
    reportEntityMap: [{ workspaceId: 'workspace-4', controlUnitId: 'cu-8' }],
    intervalType: 'day',
    intervalValue: 3,
    startTime: moment().subtract(30, 'days').toISOString(),
    reportSpec: {
      reportTitle: 'Current Every 3 Days',
      reportType: reportTypeMocks[1],
      channels: [
        {
          deviceID: 'dev-8',
          cuID: 'cu-8',
          channelID: 'ch-8',
          type: CHANNEL_TYPE.ANALOG,
          minThreshold: 0,
          maxThreshold: 100,
        },
      ],
      intervalTimeInSeconds: 3600,
      exportFormats: ['pdf', 'csv', 'json'],
    },
  },
  {
    id: 's9',
    reportEntityMap: [{ workspaceId: 'workspace-5' }],
    intervalType: 'month',
    intervalValue: 1,
    startTime: moment().subtract(6, 'months').toISOString(),
    reportSpec: {
      reportTitle: 'Frequency Monthly',
      reportType: reportTypeMocks[0],
      channels: [
        {
          deviceID: 'dev-9',
          cuID: 'cu-9',
          channelID: 'ch-9',
          type: CHANNEL_TYPE.ANALOG,
          minThreshold: 50,
          maxThreshold: 60,
        },
      ],
      intervalTimeInSeconds: 3600,
      exportFormats: ['pdf', 'csv'],
    },
  },
  {
    id: 's10',
    reportEntityMap: [{ workspaceId: 'workspace-5', groupId: 'group-4' }],
    intervalType: 'year',
    intervalValue: 1,
    startTime: moment().subtract(2, 'years').toISOString(),
    reportSpec: {
      reportTitle: 'Power Factor Yearly',
      reportType: reportTypeMocks[1],
      channels: [
        {
          deviceID: 'dev-10',
          cuID: 'cu-10',
          channelID: 'ch-10',
          type: CHANNEL_TYPE.ANALOG,
          minThreshold: 0,
          maxThreshold: 1,
        },
      ],
      intervalTimeInSeconds: 3600,
      exportFormats: ['pdf', 'json'],
    },
  },
];

export const reportsMock: Report[] = [
  {
    id: 'r1',
    reportTitle: 'Daily Energy Usage',
    reportType: reportTypeMocks[0],
    channels: [
      {
        deviceID: 'dev-1',
        cuID: 'cu-1',
        channelID: 'ch-1',
        type: CHANNEL_TYPE.ANALOG,
        minThreshold: 0,
        maxThreshold: 1000,
      },
    ],
    timeRange: {
      from: moment().subtract(1, 'days').toISOString(),
      to: moment().toISOString(),
    },
    intervalTimeInSeconds: 3600,
    exportFormats: ['pdf', 'csv'],
    sequenceReportValue: 1,
    executionState: 'completed',
    files: {
      pdf: '/files/r1.pdf',
      csv: '/files/r1.csv',
      json: '/files/r1.json',
    },
    reportScheduleId: 's1',
  },
  {
    id: 'r2',
    reportTitle: 'Weekly Temperature',
    reportType: reportTypeMocks[1],
    channels: [
      {
        deviceID: 'dev-2',
        cuID: 'cu-2',
        channelID: 'ch-2',
        type: CHANNEL_TYPE.ANALOG,
        minThreshold: -10,
        maxThreshold: 50,
      },
    ],
    timeRange: {
      from: moment().subtract(7, 'days').toISOString(),
      to: moment().toISOString(),
    },
    intervalTimeInSeconds: 7200,
    exportFormats: ['pdf', 'csv'],
    sequenceReportValue: 2,
    executionState: 'in_progress',
    files: {
      pdf: '/files/r2.pdf',
      csv: '/files/r2.csv',
      json: '',
    },
    reportScheduleId: 's2',
  },
  {
    id: 'r3',
    reportTitle: 'Monthly Humidity',
    reportType: reportTypeMocks[0],
    channels: [
      {
        deviceID: 'dev-3',
        cuID: 'cu-3',
        channelID: 'ch-3',
        type: CHANNEL_TYPE.ANALOG,
        minThreshold: 0,
        maxThreshold: 100,
      },
    ],
    timeRange: {
      from: moment().subtract(30, 'days').toISOString(),
      to: moment().toISOString(),
    },
    intervalTimeInSeconds: 86400,
    exportFormats: ['pdf', 'json'],
    sequenceReportValue: 3,
    executionState: 'pending',
    files: {
      pdf: '/files/r3.pdf',
      csv: '',
      json: '/files/r3.json',
    },
    reportScheduleId: 's3',
  },
  {
    id: 'r4',
    reportTitle: 'Voltage Check',
    reportType: reportTypeMocks[1],
    channels: [
      {
        deviceID: 'dev-4',
        cuID: 'cu-4',
        channelID: 'ch-4',
        type: CHANNEL_TYPE.ANALOG,
        minThreshold: 110,
        maxThreshold: 240,
      },
    ],
    timeRange: {
      from: moment().subtract(2, 'hours').toISOString(),
      to: moment().toISOString(),
    },
    intervalTimeInSeconds: 600,
    exportFormats: ['csv', 'json'],
    sequenceReportValue: 4,
    executionState: 'failed',
    files: {
      pdf: '',
      csv: '/files/r4.csv',
      json: '/files/r4.json',
    },
    reportScheduleId: 's4',
  },
  {
    id: 'r5',
    reportTitle: 'Pressure Monthly',
    reportType: reportTypeMocks[0],
    channels: [
      {
        deviceID: 'dev-5',
        cuID: 'cu-5',
        channelID: 'ch-5',
        type: CHANNEL_TYPE.ANALOG,
        minThreshold: 0,
        maxThreshold: 10,
      },
    ],
    timeRange: {
      from: moment().subtract(12, 'hours').toISOString(),
      to: moment().toISOString(),
    },
    intervalTimeInSeconds: 1800,
    exportFormats: ['pdf'],
    sequenceReportValue: 5,
    executionState: 'completed',
    files: {
      pdf: '/files/r5.pdf',
      csv: '',
      json: '',
    },
    reportScheduleId: 's5',
  },
  {
    id: 'r6',
    reportTitle: 'CO2 Yearly',
    reportType: reportTypeMocks[1],
    channels: [
      {
        deviceID: 'dev-6',
        cuID: 'cu-6',
        channelID: 'ch-6',
        type: CHANNEL_TYPE.ANALOG,
        minThreshold: 0,
        maxThreshold: 2000,
      },
    ],
    timeRange: {
      from: moment().subtract(3, 'days').toISOString(),
      to: moment().toISOString(),
    },
    intervalTimeInSeconds: 3600,
    exportFormats: ['csv'],
    sequenceReportValue: 6,
    executionState: 'completed',
    files: {
      pdf: '',
      csv: '/files/r6.csv',
      json: '',
    },
    reportScheduleId: 's6',
  },
  {
    id: 'r7',
    reportTitle: 'Light Intensity Biweekly',
    reportType: reportTypeMocks[0],
    channels: [
      {
        deviceID: 'dev-7',
        cuID: 'cu-7',
        channelID: 'ch-7',
        type: CHANNEL_TYPE.ANALOG,
        minThreshold: 0,
        maxThreshold: 10000,
      },
    ],
    timeRange: {
      from: moment().subtract(5, 'days').toISOString(),
      to: moment().toISOString(),
    },
    intervalTimeInSeconds: 43200,
    exportFormats: ['json'],
    sequenceReportValue: 7,
    executionState: 'completed',
    files: {
      pdf: '',
      csv: '',
      json: '/files/r7.json',
    },
    reportScheduleId: 's7',
  },
  {
    id: 'r8',
    reportTitle: 'Current Every 3 Days',
    reportType: reportTypeMocks[1],
    channels: [
      {
        deviceID: 'dev-8',
        cuID: 'cu-8',
        channelID: 'ch-8',
        type: CHANNEL_TYPE.ANALOG,
        minThreshold: 0,
        maxThreshold: 100,
      },
    ],
    timeRange: {
      from: moment().subtract(10, 'days').toISOString(),
      to: moment().toISOString(),
    },
    intervalTimeInSeconds: 3600,
    exportFormats: ['pdf', 'csv', 'json'],
    sequenceReportValue: 8,
    executionState: 'pending',
    files: {
      pdf: '/files/r8.pdf',
      csv: '/files/r8.csv',
      json: '/files/r8.json',
    },
    reportScheduleId: 's8',
  },
  {
    id: 'r9',
    reportTitle: 'Frequency Monthly',
    reportType: reportTypeMocks[0],
    channels: [
      {
        deviceID: 'dev-9',
        cuID: 'cu-9',
        channelID: 'ch-9',
        type: CHANNEL_TYPE.ANALOG,
        minThreshold: 50,
        maxThreshold: 60,
      },
    ],
    timeRange: {
      from: moment().subtract(15, 'days').toISOString(),
      to: moment().toISOString(),
    },
    intervalTimeInSeconds: 3600,
    exportFormats: ['pdf', 'csv'],
    sequenceReportValue: 9,
    executionState: 'completed',
    files: {
      pdf: '/files/r9.pdf',
      csv: '/files/r9.csv',
      json: '',
    },
    reportScheduleId: 's9',
  },
  {
    id: 'r10',
    reportTitle: 'Power Factor Yearly',
    reportType: reportTypeMocks[1],
    channels: [
      {
        deviceID: 'dev-10',
        cuID: 'cu-10',
        channelID: 'ch-10',
        type: CHANNEL_TYPE.ANALOG,
        minThreshold: 0,
        maxThreshold: 1,
      },
    ],
    timeRange: {
      from: moment().subtract(20, 'days').toISOString(),
      to: moment().toISOString(),
    },
    intervalTimeInSeconds: 3600,
    exportFormats: ['pdf', 'json'],
    sequenceReportValue: 10,
    executionState: 'completed',
    files: {
      pdf: '/files/r10.pdf',
      csv: '',
      json: '/files/r10.json',
    },
    reportScheduleId: 's10',
  },
];
